import ProductEnablement from '@/views/productEnablement/Index'

export default [
  {
    path: ':clientId/product-enablement',
    name: 'productEnablement.index',
    component: ProductEnablement
  }
]
